export enum CommitteeType {
    reassessment = 'REASSESSMENT',
    grading = 'GRADING',
}

export enum MarksReportAccessLevel {
    VIEW_INDIVIDUAL_MARKS = 'view_individual_marks',
    VIEW_AVERAGE_MARKS = 'view_average_marks',
}
